import React from 'react';

export function Select(props: React.SelectHTMLAttributes<HTMLSelectElement>) {
  const { className = '', children, ...rest } = props;
  
  // Extract width-related classes from className to apply to wrapper
  const widthClasses = className.split(' ').filter(cls => 
    cls.startsWith('w-') || cls.startsWith('max-w-') || cls.startsWith('min-w-')
  ).join(' ');
  
  // Remove width classes from select element classes
  const selectClasses = className.split(' ').filter(cls => 
    !cls.startsWith('w-') && !cls.startsWith('max-w-') && !cls.startsWith('min-w-')
  ).join(' ');
  
  return (
    <div className={`relative ${widthClasses || 'w-full'}`}>
      <select
        className={`block w-full appearance-none rounded-lg bg-bg-raised px-3.5 py-2.5 pr-9 text-sm text-content-primary shadow-sm ring-0 outline-none transition-shadow duration-200 focus:shadow-md focus:ring-2 focus:ring-blueberry-200/50 cursor-pointer ${selectClasses}`}
        {...rest}
      >
        {children}
      </select>
      <svg
        aria-hidden="true"
        className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-icon-subtle"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    </div>
  );
}

